import { Fragment } from "react";
import { FormattedMessage } from "react-intl";
import Separator from "app/pages/.shared/Separator";
import MoreDetails from "app/pages/.shared/MoreDetails";
import IconShield from "app/pages/.shared/static/icons/IconShield";
import PropTypes from "prop-types";
import { htmlSanitize } from "app/utils/sanitize";

const InsuranceContentWithInsurance = ({ insurance, note, isFirstItem }) => {
	return (
		<Fragment>
			{insurance.title2 && (
				<div className="insurances__covid-shield">
					<IconShield /> {insurance.title2}
				</div>
			)}
			{insurance.intro && (
				<div className="insurances__headline">
					<Separator />
					{insurance.intro}
				</div>
			)}
			<MoreDetails
				initialExpanded={isFirstItem}
				headerPosition="bottom"
				expandedLabel={<FormattedMessage id="product.page.less.details" />}
				collapsedLabel={<FormattedMessage id="product.page.more.details" />}
			>
				<div className="insurances__details">
					{!insurance.intro && <Separator />}
					<div className="insurances__title">
						<FormattedMessage id="payment.insurance.details.title" />
					</div>
					<div className="insurances__details-list">
						<div
							className="list"
							dangerouslySetInnerHTML={{
								__html: htmlSanitize(insurance.details),
							}}
						/>
					</div>

					{note && <div className="insurances__note">{note}</div>}

					{insurance.document && (
						<div className="insurances__link">
							<a rel="noopener noreferrer" target="_blank" href={insurance.document}>
								<FormattedMessage id="payment.insurance.link.label" />
							</a>
						</div>
					)}
				</div>
			</MoreDetails>
		</Fragment>
	);
};
InsuranceContentWithInsurance.propTypes = {
	insurance: PropTypes.object,
	isFirstItem: PropTypes.bool,
	note: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default InsuranceContentWithInsurance;
